<template>
  <iframe ref="preview_iframe"
          frameborder="0"
          style="width: 100%; height: 100%;"></iframe>
</template>

<script>
import {ResourceImpl} from 'hal-client';

export default {
  name: 'referral-view-email',
  props: {
    referralResource: ResourceImpl
  },
  data () {
    return {
      html: null
    };
  },
  watch: {
    html: {
      immediate: true,
      handler (value) {
        if (value) {
          this.$refs.preview_iframe.srcdoc = value;
        }
      }
    }
  },
  mounted () {
    this.$http.get(this.referralResource.$href('preview'))
      .then(res => {
        this.html = res.data;
      });
  }
};
</script>

<style scoped>

</style>
